<template>
  <div class="page--full team bg-light-blue">
    <div class="team__wrapper">
      <!-- <transition name="fadeInUp"> -->
      <h1 class="team__header" v-if="showContentByPaging">
        <span class="header">Our team<br />of builders</span>
      </h1>
      <!-- </transition> -->
      <el-row :gutter="20">
        <el-col
          :xs="6"
          :sm="4"
          v-for="(item, index) in members"
          :key="index"
          style="min-height: calc(width);"
        >
          <div class="member">
            <ImageWithLoader
              :src="item.src"
              :preloadSrc="require('@/assets/images/team/team_preload.png')"
              class="member__image"
            />
            <div class="member__link">
              <h3 v-html="item.name" />
              <p>
                <span>&mdash;</span><a :href="item.link">{{ item.linkText }}</a>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import contentAnimation from '@/mixins/contentAnimation';
import ImageWithLoader from '@/components/ImageWithLoader.vue';

export default {
  mixins: [contentAnimation],
  components: {
    ImageWithLoader,
  },
  data() {
    return {
      members: [
        {
          src: require('@/assets/images/team/andrew.jpg'),
          alt: 'andrew',
          name: 'Andrew<br/>Jiang',
          link: 'https://www.linkedin.com/in/andrewjiang/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/jesse.jpg'),
          alt: 'jesse',
          name: 'Jesse<br/>Sum',
          link: 'https://www.linkedin.com/in/jhysum/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/son.jpg'),
          alt: 'son',
          name: 'N.<br/>Son Min',
          link: 'https://www.linkedin.com/in/sonmin501/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/florian.jpg'),
          alt: 'florian',
          name: 'Florian<br/>Delizy',
          link: 'https://www.linkedin.com/in/floriandelizy',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/arel.jpg'),
          alt: 'arel',
          name: 'Arel<br/>Lin',
          link: 'https://www.linkedin.com/in/arel-hello/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/kevin.jpg'),
          alt: 'kevin',
          name: 'Kevin<br/>Marlow',
          link: 'https://www.linkedin.com/in/kevinmmarlow/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/chris.jpg'),
          alt: 'chris',
          name: 'Chris<br/>Davis',
          link: 'https://www.linkedin.com/in/chris-davis-0059311/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/stacy.jpg'),
          alt: 'stacy',
          name: 'Stacy<br/>Chen',
          link: 'https://www.linkedin.com/in/stacycchen6527/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/jillian.jpg'),
          alt: 'jillian',
          name: 'Jillian<br/>Evans',
          link: 'https://www.linkedin.com/in/jillianrevans/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/henry.jpg'),
          alt: 'henry',
          name: 'Henry<br/>Chou',
          link: 'https://www.linkedin.com/in/hung-lin-chou/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/allyson.jpg'),
          alt: 'allyson',
          name: 'Allyson<br/>Rudd',
          link: 'https://www.linkedin.com/in/allysonrudd/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/jasmyne.jpg'),
          alt: 'jasmyne',
          name: 'Jasmyne<br/>Johnson',
          link: 'https://www.linkedin.com/in/jasmynecjohnson/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/ryan.jpg'),
          alt: 'ryan',
          name: 'Ryan<br/>Ho',
          link: 'https://www.linkedin.com/in/horyan/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/alex.jpg'),
          alt: 'Alex',
          name: 'Alex<br/>Tseng',
          link: 'https://www.linkedin.com/in/alxtz/',
          linkText: 'in',
        },
        {
          src: require('@/assets/images/team/jon.jpg'),
          alt: 'jon',
          name: 'Jon<br/>Wright',
          link: 'https://www.linkedin.com/in/jonrwright/',
          linkText: 'in',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.team {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__wrapper {
    width: 90%;
    padding-top: 2rem;
    @media (min-width: $sm) {
      width: 76%;
      padding-top: 0;
    }
    @media (min-width: $xl) {
      width: 70%;
    }
    @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
      (max-width: $xs) {
      width: 82%;
    }
  }
}

.member {
  $this: &;
  margin-bottom: 1rem;
  @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
    (max-width: $xs) {
    margin-bottom: 0.6rem;
  }
  position: relative;
  @media (min-width: $sm) {
    &:hover {
      & #{$this}__link {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
  &__link {
    box-sizing: border-box;
    padding: 0.5rem;
    @media (min-width: $sm) {
      padding: 1rem;
    }
    @media (min-width: $xl) {
      padding: 1.75rem 2.25rem 1rem;
    }
    opacity: 0;
    transform: scale(0.8);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $color-primary;
    transition: all 0.3s ease;
    color: $color-white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
      margin: 0;
      @media (min-width: $sm) {
        font-size: 1.5rem;
        line-height: 1.08;
      }
      @media (min-width: $xl) {
        font-size: 2rem;
      }
    }
    p {
      font-size: 1.5rem;
      @media (min-width: $xl) {
        font-size: 2rem;
      }
      font-weight: bold;
      text-align: right;
      margin: 0;
      span {
        margin-right: 0.5rem;
        transition: all 0.3s ease;
        cursor: default;
      }
      a {
        color: $color-white;
        text-decoration: none;
      }
      &:hover {
        span {
          margin-right: 1.5rem;
        }
      }
    }
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.5s;
}
.fadeInUp-leave-active {
  animation: fadeInUp 0.5s reverse;
}
</style>
